import React, {useEffect} from 'react'
import { withRouter } from 'react-router'
import {projectsData} from '../../fake-database/index';
import AOS from 'aos';
import "aos/dist/aos.css";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";
// import Swiper core and required modules
import SwiperCore, {
     Mousewheel} from 'swiper';

// Import Swiper styles
import 'swiper/swiper.min.css'
import './projects.css'
// install Swiper modules


SwiperCore.use([Mousewheel]);

const Project = (props) => {
    //    const goodId = parseInt(id);
    // if(goodId !=0 && !goodId){
    //         return <Redirect to={{pathname:'/404'}}/>
    // }
    const matchId = props.match.params.id;
    const selectedProject = projectsData.project.find(item => item.id == matchId );

    useEffect(() => {
        AOS.init({
          duration : 700
        });
      }, []);

    return (
        <div id="project" className="pt-5 mt-5 ">
              <div className="text-white text-center mt-2 px-3">
                <h1 className="mb-0">{selectedProject.name}</h1>
            </div>
            <Swiper 
                      slidesPerView={"auto"}
                    mousewheel={true}
                    spaceBetween={30}
                    grabCursor={true} 
                 // Responsive breakpoints
                    breakpoints={{
                    // when window width is >= 640px
                    640: {
                        width: 640,
                        slidesPerView: 1,
                    },
                    // when window width is >= 768px
                    768: {
                        width: 768,
                        slidesPerView: 1,
                        },
                    }}
                    className="mySwiper text-white mt-5"
                >
                {selectedProject.image.map( projectImage => (
                    <SwiperSlide key={projectImage.id}>
                        <div className="d-flex project justify-content-center align-items-start"> 
                            <div className="number" data-aos="fade-right" data-aos-delay="150">
                                <p className="mb-0 mx-1">{projectImage.id}/{selectedProject.image.length}</p>
                            </div>
                            <div className="content text-center">
                                <div>
                                    <picture>
                                        <source alt={selectedProject.imageAlt} srcSet={projectImage.imagePathWebp}/>
                                        <img src={projectImage.imagePath} alt={selectedProject.imageAlt} className="img-fluid"/>
                                    </picture>
                                </div>
                            </div>
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
        </div>

        // {/* {selectedProject.find( slide => (
        //     slide.id
        //     ))}
        // No. {id}
        // name {props.match.params.name} */}
    )
}

export default Project
